import { render, staticRenderFns } from "./bloodPressureReport.vue?vue&type=template&id=1987ef8c&scoped=true"
import script from "./bloodPressureReport.vue?vue&type=script&lang=js"
export * from "./bloodPressureReport.vue?vue&type=script&lang=js"
import style0 from "./bloodPressureReport.vue?vue&type=style&index=0&id=1987ef8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987ef8c",
  null
  
)

export default component.exports